
import React from 'react';
import TranslatedText from '@/TranslatedText';

const NewArrivalsHeader: React.FC = () => {
  return (
    <h2 className="text-2xl md:text-3xl font-bold mb-4 text-ahavex-blue border-b-2 border-ahavex-gold pb-2 inline-block">
      <TranslatedText text="New Arrivals" />
    </h2>
  );
};

export default NewArrivalsHeader;
